import React from "react";
import Slider from "./Slider";
import SliderTabs from "./SliderTabs";
import WhyChooseUs from "./WhyChooseUs";
import CampusSection from "./CampusSection";
import WelcomeSection from "./WelcomeSection";

import OurApproach from "./OurApproach";
import PrincipalMessage from "./PrincipalMessage";
import SchoolCurricula from "./SchoolCurricula";
import AcademicExcellence from "./AcademicExcellence";
import SchoolLevels from "./SchoolLevels/SchoolLevels";
import HolisticPillars from "./HolisticPillars";
import ParentTestimonials from "./ParentTestimonials";
import SchoolCampus from "./SchoolCampus";
import BusRoutes from "./BusRoutes";
import SchoolFAQ from "./SchoolFAQ";
const Home = () => {
  return (
    <div className="career-page">
      <Slider />

      <SliderTabs />
      <WhyChooseUs />
      <CampusSection />

      <SchoolCurricula />

      <AcademicExcellence />
      <WelcomeSection />
      <SchoolLevels />

      <HolisticPillars />

      <OurApproach />
      <PrincipalMessage />
      <ParentTestimonials />
      <SchoolCampus />
      <BusRoutes />
      <SchoolFAQ />
      
    </div>
  );
};

export default Home;
